
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("cg8m4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $fe01469e35b06615$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Danish (Denmark)
var $fe01469e35b06615$export$2e2bcd8739ae039 = {
    'fabric.editor.chromeCollapsedPlaceholder': "Skriv noget\xa0\u2026",
    'fabric.editor.editorAssistiveLabel': "Omr\xe5de for hovedindhold. Begynd at taste for at skrive tekst.",
    'fabric.editor.headingLink.toolbarHelpTitle': "\xc5bn dialogboksen Hj\xe6lp"
};

});


//# sourceMappingURL=da.e378dadd.js.map
